import { DOCUMENT, inject, Injectable } from '@angular/core';
import { Colors, CorporateDesign, Fonts, Icons } from '../models/organisation.model';

@Injectable({
  providedIn: 'root',
})
export class CorporateDesignService {
  private document = inject<Document>(DOCUMENT);

  dom: Document;
  root: HTMLElement;

  constructor() {
    const document = this.document;

    this.dom = document;
    this.root = this.dom.querySelector(':root')!;
  }

  updateTheme(corporateDesign: CorporateDesign, assetBucketUrl: string) {
    this.updateColors(corporateDesign.colors);
    this.updateIcons(corporateDesign.icons, assetBucketUrl);
    this.updateFonts(corporateDesign.fonts);
  }

  updateColors(colors: Colors) {
    this.root.style.setProperty('--primary-color', colors.primaryTextColor);
    this.root.style.setProperty('--primary-background-color', colors.primaryBackgroundColor);
    this.root.style.setProperty('--font-color', colors.primaryTextColor);
    this.root.style.setProperty('--font-color-secondary', colors.secondaryTextColor);
    this.root.style.setProperty('--font-color-tertiary', colors.tertiaryTextColor);
    this.root.style.setProperty('--info-background-color', colors.secondaryBackgroundColor);
    this.root.style.setProperty('--error-color', colors.errorColor);
    this.root.style.setProperty('--primary-button-background-color', colors.activeUiColor);
    this.root.style.setProperty('--disabled-button-background-color', colors.inactiveUiColor);
    this.root.style.setProperty('--primary-button-font-color', colors.activeUiTextColor);
    this.root.style.setProperty('--disabled-button-font-color', colors.inactiveUiTextColor);
    this.root.style.setProperty('--secondary-button-font-color', colors.primaryTextColor);
    this.root.style.setProperty('--secondary-button-background-color', colors.tertiaryBackgroundColor);
    this.root.style.setProperty('--tertiary-background-color', colors.tertiaryBackgroundColor);
  }

  updateIcons(icons: Icons, assetBucketUrl: string): void {
    const faviconSvg = this.dom.querySelector('#favicon-svg') as HTMLLinkElement;
    const faviconIco = this.dom.querySelector('#favicon-ico') as HTMLLinkElement;

    faviconSvg.setAttribute('href', assetBucketUrl + icons.faviconSvg);
    faviconIco.setAttribute('href', assetBucketUrl + icons.faviconIco);

    this.updateIcon('--slider-thumb-active-icon', assetBucketUrl, icons.customIcons.sliderThumb);
    this.updateIcon('--arrow-button', assetBucketUrl, icons.customIcons.arrowButton);
    this.updateIcon('--success-tick', assetBucketUrl, icons.customIcons.success);
  }

  private updateIcon(variable: string, assetBucketUrl: string, assetPath: string | undefined): void {
    if (!assetPath) return;

    this.root.style.setProperty(variable, `url("${assetBucketUrl}${assetPath}")`);
  }

  updateFonts(fonts: Fonts): void {
    this.root.style.setProperty('--font-family', fonts.primaryFont);
  }

  getColor(name: string) {
    return this.root.style.getPropertyValue(name);
  }
}
